import * as types from "./types";

export const setApikeysData = (responseData) => ({
  type: types.SET_DATA,
  payload: responseData,
});

export const getApikeys = (options) => ({
  type: types.REQUEST_READ,
  payload: options,
});
